module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAAG9JREFUGBljYEAD////Pw/Em4FYGE0KkwtUBAMPgQwTTBVIIjCVUPoHkE6DS6NJ4uLOB0pwMIJk4TrxMw4x4ZdHkX3HADKZCNADVMOMohXEQdP4FciPwFAEE0BSfBfI1oOJY6WBCs4BMShSBNEVAACHRrQyd4V+gAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right-icon.png
// module id = USev
// module chunks = 17